import React, { Fragment, useState, useEffect } from "react";
import Starter from "../../component/Starter";
import {
  monthList,
  tableSkeleton,
  yearList
} from "../../constant/helper/helper";
import SelectInput2 from "../../component/input/SelectInput2";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import Button from "../../component/button/Button";
import { useSelector, useDispatch } from "react-redux";
import { accessActions } from "../../redux/actions";
import isEmpty from "../../validation/isEmpty";
import { helperFunction } from "../../constant/helper";
import moment from "moment";
import SelectInput from "../../component/input/SelectInput";
import TextInput from "../../component/input/TextInput";

const Updates = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;

  const [values, setValues] = useState({
    year: "",
    month: ""
  });
  const [data, setData] = useState({
    type: "",
    title: "",
    description: "",
    updatePatch: "",
    latestVersion: ""
  });

  const [updates, setUpdates] = useState([]);
  const { accessLoading, allUpdates, accessError, accessResponse } =
    useSelector((state) => state.access);
  useEffect(() => {
    if (accessError) {
      helperFunction.toastHelper("error", accessError);
    }
    if (accessResponse) {
      helperFunction.toastHelper("success", accessResponse);
    }
  }, [accessError, accessResponse]);

  console.log(allUpdates);

  useEffect(() => {
    if (!isEmpty(allUpdates)) {
      setUpdates(allUpdates);
    } else {
      setUpdates([]);
    }
  }, [allUpdates]);

  const onChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const onChangeData = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    console.log(name, value);
    setData({ ...data, [name]: value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!isEmpty(values.year) && !isEmpty(values.month)) {
      dispatch(accessActions.setAccessLoading(true));
      dispatch(accessActions.clearAccessErrors());
      dispatch(accessActions.clearAccessResult());
      dispatch(
        accessActions.getAllUpdates(
          "ALL",
          values.year,
          values.month,
          loginType
        )
      );
    } else {
      helperFunction.toastHelper(
        "error",
        "YEAR or MONTH is not selected"
      );
    }
  };

  const updateList = (updateData) => {
    if (accessLoading) {
      return <tr>{tableSkeleton(7)}</tr>;
    } else if (updateData === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">Please Select Year and Date</span>
          </td>
        </tr>
      );
    } else if (updateData.length === 0) {
      return (
        <tr
          style={{
            top: "50%",
            left: "50%",
            position: "absolute",
            transform: "translate(-50%, -50%)"
          }}
        >
          <td>
            <span className="">
              No Record Found for month {values.month} - {values.year}
            </span>
          </td>
        </tr>
      );
    } else if (!isEmpty(updateData) && updateData.length > 0) {
      return updateData.map((updateSingleData, index) => (
        <tr style={{ fontSize: "12px" }} key={index}>
          <td>{index + 1}</td>
          <td className="text-center">
            {moment(
              !isEmpty(updateSingleData.createdAt)
                ? updateSingleData.createdAt
                : values.date
            ).format("DD-MM-yyyy")}
          </td>
          <td className="text-center">{updateSingleData.type}</td>
          <td className="text-center">{updateSingleData.title}</td>
          <td className="text-center">
            {updateSingleData.description}
          </td>
          <td className="text-center">
            {updateSingleData.latestVersion}
          </td>
          <td className="text-center">
            {moment(updateSingleData.updatePatch).format(
              "DD/MM/YYYY"
            )}
          </td>
        </tr>
      ));
    }
  };

  const onAddUpdateSubmit = (e) => {
    e.preventDefault();
    dispatch(accessActions.setAccessLoading(true));
    dispatch(accessActions.clearAccessErrors());
    dispatch(accessActions.clearAccessResult());

    dispatch(accessActions.addUpdates(data, loginType));
  };

  const addUpdateModal = () => {
    return (
      <div
        className="modal fade"
        id="add_update"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="fullWidthModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="fullWidthModalLabel">
                Add Updates
              </h4>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>

            <form className="pl-3 pr-3" onSubmit={onAddUpdateSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <h4 className="mt-1">Add App Update</h4>
                    <p className="text-muted mb-2">
                      Fill the form below to Add Update .
                    </p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-lg-6 col-xl-6 mt-1">
                    <SelectInput
                      name="type"
                      required={true}
                      textWhite={false}
                      isLabeled={false}
                      value={data.type}
                      label="Select Type"
                      onChange={onChangeData}
                    >
                      <option value=""> Select Type</option>
                      <option value="OTA">OTA</option>
                      <option value="STORE">STORE</option>
                    </SelectInput>
                  </div>
                  <div className="col-md-6 col-lg-6 col-xl-6 mt-1">
                    <TextInput
                      type="text"
                      name="title"
                      label="Title"
                      required={true}
                      textWhite={false}
                      value={data.title}
                      placeholder="Title"
                      onChange={onChangeData}
                    />
                  </div>
                  <div className="col-md-6 col-lg-6 col-xl-6 mt-1">
                    <TextInput
                      type="text"
                      required={true}
                      textWhite={false}
                      name="latestVersion"
                      label="Latest Version"
                      onChange={onChangeData}
                      value={data.latestVersion}
                      placeholder="Latest Version"
                    />
                  </div>
                  <div className="col-md-6 col-lg-6 col-xl-6 mt-1">
                    <TextInput
                      type="date"
                      required={true}
                      textWhite={false}
                      name="updatePatch"
                      onChange={onChangeData}
                      value={data.updatePatch}
                      label="Update Patch date"
                      placeholder="Update Patch date"
                    />
                  </div>
                  <div className="col-md-12 col-lg-12 col-xl-12 mt-1">
                    <TextInput
                      type="text"
                      required={true}
                      textWhite={false}
                      name="description"
                      label="Description"
                      onChange={onChangeData}
                      value={data.description}
                      placeholder="Description"
                    />
                  </div>
                  {accessLoading ? (
                    <div className="col-sm-4 col-md-4 col-lg-4 mt-2">
                      <SpinnerButton />
                    </div>
                  ) : (
                    <div className="col-sm-4 col-md-4 col-lg-4 mt-2">
                      <div className="form-group">
                        <Button
                          title="GET"
                          type="submit"
                          isBackgroundColor={false}
                          icon="mdi mdi-plus-circle-outline mr-2"
                          className="btn mb-2 text-white btn-dark btn-block"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Starter
      topBarTitle="All Updates"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Access Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Updates</a>
          </li>
          <li className="breadcrumb-item active">All Updates</li>
        </Fragment>
      }
    >
      <div className="row mt-2">
        <div className="col-lg-3 col-md-3 col-sm-12">
          <SelectInput2
            data-tip
            name="month"
            isLabeled={true}
            onChange={onChange}
            data-for="monthName"
            label="Select Month"
            value={values.month}
            placeholder="Select Month"
            icon="mdi mdi-map-marker-radius"
          >
            {Object.values(monthList).map((data, i) => (
              <option key={i} value={data}>
                {data}
              </option>
            ))}
          </SelectInput2>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12">
          <SelectInput2
            data-tip
            name="year"
            isLabeled={true}
            onChange={onChange}
            data-for="yearName"
            label="Select Year"
            value={values.year}
            placeholder="Select Year"
            icon="mdi mdi-map-marker-radius"
          >
            {Object.values(yearList).map((data, i) => (
              <option key={i} value={data}>
                {data}
              </option>
            ))}
          </SelectInput2>
        </div>
        {accessLoading ? (
          <div className="col-sm-3 col-md-3 col-lg-3">
            <SpinnerButton />
          </div>
        ) : (
          <div className="col-sm-3 col-md-3 col-lg-3">
            <div className="form-group">
              <Button
                title="GET"
                type="button"
                onClick={onSubmit}
                isBackgroundColor={false}
                icon="mdi mdi-plus-circle-outline mr-2"
                className="btn mb-2 text-white btn-dark btn-block"
              />
            </div>
          </div>
        )}
        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
          <Button
            data-tip
            type="button"
            data-for="addUpdates"
            isBackgroundColor={false}
            title="Add Updates"
            icon="mdi mdi-database-plus mr-2"
            data-toggle="modal"
            data-target="#add_update"
            className="btn text-white btn-block btn-primary float-right"
          />
        </div>
        {addUpdateModal()}
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            className="table-responsive"
            style={{
              height: "700px",
              overflow: "auto",
              position: "relative"
            }}
          >
            <table
              className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
              id="products-datatable"
            >
              <thead className="thead-light">
                <tr>
                  <th style={{ width: "20px" }}>#</th>
                  <th className="text-center">Date</th>
                  <th className="text-center">Type</th>
                  <th className="text-center">Title</th>
                  <th className="text-center">Description</th>
                  <th className="text-center">Version</th>
                  <th className="text-center">Patch Date</th>
                </tr>
              </thead>
              <tbody>{updateList(updates)}</tbody>
            </table>
          </div>
        </div>
      </div>
    </Starter>
  );
};

export default Updates;
